<template>
  <div>
    <v-row align="center">

      <!-- Foto -->
      <v-col cols="12" lg="6">
        <img
          :src="require('@/assets/images/brde-award.png')"
          class="award-photo"
          loading="lazy"
          alt="Premiação BRDE Labs SC Growth"
        />
      </v-col>

      <!-- Conteúdo -->
      <v-col cols="12" lg="6">

        <!-- Badge topo -->
        <div class="award-tag">
          <v-icon small class="mr-1" color="amber darken-1">mdi-trophy</v-icon>
          <span>Premiação 2025</span>
        </div>

        <!-- Headline -->
        <h2 class="award-title mt-4">
          ZaperMenu foi <span class="award-highlight">premiado</span> no programa BRDE Labs SC Growth!
        </h2>

        <!-- Card logos -->
        <div class="logos-card mt-5">
          <span class="logos-label">Realização:</span>
          <div class="logos-wrap">
            <img
              :src="require('@/assets/images/brde-acate.png')"
              class="brde-acate-img"
              loading="lazy"
              alt="BRDE e ACATE"
            />
          </div>
        </div>

        <!-- Descrição -->
        <p class="award-desc mt-5">
          O BRDE Labs SC é considerado um dos principais programas de aceleração de Santa Catarina,
          com foco em <strong>inovação, sustentabilidade e crescimento.</strong>
        </p>

        <!-- Conclusão destacada -->
        <div class="award-conclusion mt-4">
          <v-icon small class="mr-2" color="success">mdi-check-circle</v-icon>
          Esse resultado mostra que estamos no caminho certo — construindo processos mais sólidos e profissionais.
        </div>

      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: "BrdeLabsAwardSection",
  };
</script>

<style lang="scss" scoped>
  /* Foto */
  .award-photo {
    max-height: 560px;
    max-width: 100%;
    width: 100%;
    border-radius: 20px;
    display: block;
    object-fit: cover;
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.45);
  }

  /* Badge "Premiação 2025" */
  .award-tag {
    display: inline-flex;
    align-items: center;
    padding: 5px 14px;
    border-radius: 999px;
    border: 1px solid rgba(255, 180, 0, 0.4);
    background: rgba(255, 180, 0, 0.08);
    font-size: 13px;
    font-weight: 600;
    color: #f5a623;
    letter-spacing: 0.02em;
  }

  /* Headline */
  .award-title {
    font-size: 26px;
    font-weight: 600;
    line-height: 1.4;
    color: var(--text-primary);

    @media (max-width: 600px) {
      font-size: 22px;
    }
  }

  .award-highlight {
    color: #f40612;
  }

  /* Card das logos */
  .logos-card {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 16px 20px;
    border-radius: 14px;
    background: var(--card-bg);
    border: 1px solid var(--card-border);
  }

  .logos-label {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--text-muted);
  }

  .logos-wrap {
    background: #1a1a1a;
    border-radius: 8px;
    padding: 6px 12px;
    display: inline-block;
  }

  .brde-acate-img {
    height: 38px;
    display: block;
  }

  /* Descrição */
  .award-desc {
    font-size: 16px;
    line-height: 1.7;
    color: var(--text-secondary);
    margin: 0;
  }

  /* Conclusão */
  .award-conclusion {
    display: flex;
    align-items: flex-start;
    gap: 4px;
    padding: 14px 18px;
    border-radius: 14px;
    border: 1px solid var(--card-border);
    border-left: 3px solid #23cf65;
    background: var(--card-bg);
    font-size: 15px;
    line-height: 1.6;
    color: var(--text-secondary);
  }
</style>
